import { render, staticRenderFns } from "./students-certs.vue?vue&type=template&id=69027048&"
import script from "./students-certs.vue?vue&type=script&lang=js&"
export * from "./students-certs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports